<ng-container *ngIf="errors.length && !isOwnError">
    <ng-container *ngIf="isProd; else dev">
        <div class="technical-info" [innerHTML]="errors[0]?.error?.errors ?? ('ERRORS.HTTP.MESSAGES.GENERAL_PUBLIC' | translate)"></div>
    </ng-container>
    <ng-template #dev>
        <div class="technical-info">Status : {{ errors[0].status }}</div>
        <div class="technical-info">Ok : {{ errors[0].ok }}</div>
        <div class="technical-info">Message : {{ errors[0].message }}</div>
        <div class="technical-info">{{ errors[0]?.error?.errors }}</div>
    </ng-template>
</ng-container>

<ng-container *ngIf="errors.length && isOwnError">
    <ng-container *ngFor="let error of errors">
        <ng-container *ngIf="isProd; else dev">
            <div class="technical-info" [innerHTML]="(error ?? 'ERRORS.HTTP.MESSAGES.GENERAL_PUBLIC') | translate"></div>
        </ng-container>
        <ng-template #dev>
            <div class="technical-info">{{ error | translate }}</div>
        </ng-template>
    </ng-container>
</ng-container>
